module.exports = __webpack_public_path__ + "static/media/bm.9c782341.svg";